import { atom } from 'jotai';
import { IGalleryArticleDetail } from 'shared/models';

export const $CurrentGalleryArticle = atom({} as IGalleryArticleDetail);
